import React from 'react';
import { Box, Text } from 'grommet';

import { getAppNameWithVersion, getProjectName } from '../utils';

const FooterText = ({text}) => {
    return <Text size="xsmall" color="dark-3">{text}</Text>;
}

const FooterColumn = ({children, position}) => {
    return (
        <Box align={position} basis="1/3">
            {children}
        </Box>
    );
}

const PageFooter = ({title, link, ...props}) => {
    return (
        <Box margin={{top: '12px'}} pad={{top: '12px', bottom: '12px'}} border={{side: 'top', color: 'light-2'}} direction="row" {...props} >
            <FooterColumn position="start">
                <FooterText text={`Projekt: ${getProjectName()}`}/>
            </FooterColumn>
            <FooterColumn position="center">
                <FooterText text="..."/>
            </FooterColumn>
            <FooterColumn position="end">
                <FooterText text={getAppNameWithVersion()} />
            </FooterColumn>
        </Box>
    );
};

export default PageFooter;
